var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paste_code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.825,
    height: 20.825,
    viewBox: "0 0 20.825 20.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9967",
    "data-name": "Path 9967",
    d: "M0,0H20.825V20.825H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9968",
    "data-name": "Path 9968",
    d: "M8.471,5H6.735A1.735,1.735,0,0,0,5,6.735V17.148a1.735,1.735,0,0,0,1.735,1.735h8.677a1.735,1.735,0,0,0,1.735-1.735V6.735A1.735,1.735,0,0,0,15.412,5H13.677",
    transform: "translate(-0.661 -0.661)",
    fill: "none",
    stroke: "#595c5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9969",
    "data-name": "Path 9969",
    d: "M9,3,9,4.735A1.735,1.735,0,0,1,10.735,3h1.735a1.735,1.735,0,0,1,1.735,1.735h0a1.735,1.735,0,0,1-1.735,1.735H10.735A1.735,1.735,0,0,1,9,4.735Z",
    transform: "translate(-1.191 -0.397)",
    fill: "none",
    stroke: "#595c5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteIcon);
export default __webpack_public_path__ + "static/media/pasteIcon.6d94d7524f446611f5812222758079f4.svg";
export { ForwardRef as ReactComponent };